import Pedidos from '~/services/pedidos/pedidos-tienda'
import Historial from '~/services/pedidos/pedidos-historial'

export const state = {
    pedidos:[],
    paginate:{},
    id_pedido:null,
    productos:[],
    pedido:{},
    cliente:{},
    historial:[],
    resumenes:{inicial:{},final:{}},
    pagos:[],
    cuotas:[],
    convenio: {},

}

export const getters = {
    pedidos: state => state.pedidos,
    paginate: state => state.paginate,
    id_pedido: state => state.id_pedido,
    productos: state => state.productos,
    pedido: state => state.pedido,
    cliente: state => state.cliente,
    historial: state => state.historial,
    resumenes: state => state.resumenes,
    pagos: state => state.pagos,
    cuotas: state => state.cuotas,
    convenio: state => state.convenio,

}

export const mutations = {

    set_pedidos: (state,payload) => {
        state.pedidos = payload
    },
    set_paginate: (state,payload) => {
        state.paginate = payload
    },
    set_id_pedido: (state,payload) => {
        state.id_pedido = null
        state.id_pedido = payload
    },
    set_productos: (state,payload) => {
        state.productos = payload
    },
    set_pedido: (state,payload) => {
        state.pedido = payload
    },
    set_cliente: (state,payload) => {
        state.cliente = payload
    },
    set_resumenes: (state,payload) => {
        state.resumenes = payload
    },
    set_convenio: (state,payload) => {
        state.convenio = payload
    },
    set_historial: (state,payload) => {
        let mensajes = [
            'Un cliente ha solicitado un pedido',
            'Pedido Confirmado',
            'Pedido con cambios',
            'Pedido En Alistamiento',
            'Pedido En Empaque',
            'Pedido Enviado',
            'Pedido Entregado',
            'Pedido Cancelado',
            'Reclamo',
        ]

        let iconos = [
            'icon-receipt',
            'icon-ok-circled-outline',
            'icon-account-edit',
            'icon-cart-arrow-down',
            'icon-shopping-outline',
            'icon-truck-outline',
            'icon-shopping',
            'icon-attention-outline',
        ]

        let history = []
        for (let idx in payload){
            if(idx == 2 || idx == 7 || idx == 8){

                if(payload[idx] !== null){
                    let estado = state.pedido.estado
                    // console.log(estado);
                    let icon = ''
                    switch (estado){
                    case 25:
                        icon = 'icon-playlist-remove'
                        break;
                    case 26:
                        icon = 'icon-cancel-circled-outline'
                        break;
                    case 27:
                        icon = 'icon-account-remove-outline'
                        break;
                    default:
                        icon ='icon-attention-outline'
                    }

                    history.push({ content:mensajes[idx], hora:payload[idx], activo: payload[idx] !== null, icon:icon })
                }
            }else{
                history.push({ content:mensajes[idx], hora:payload[idx], activo: payload[idx] !== null, icon:iconos[idx] })
            }
        }
        state.historial = history
    },
    set_credito: (state,payload) => {
        state.cuotas = payload.cuotas
        state.pagos = payload.pagos
    },
}

export const actions = {
    async listar_pedidos({commit},payload){
        const {data} = await Historial.listar_pedidos(payload)
        /*
        commit('set_paginate',data.pedidos)
        commit('set_pedidos',data.pedidos.data)
        */
        commit('set_pedidos',data.pedidos)
    },
    async pedidos_productos({commit},id){
        const {data} = await Pedidos.pedidos_productos(id)
        commit('set_productos',data.productos)
    },
    async get_datos({commit},id){
        const {data} = await Pedidos.get_datos(id)
        commit('set_pedido',data.pedido)
        commit('set_cliente',data.cliente)
        commit('set_convenio',data.convenio)
    },
    async pedidos_historial({commit},id){
        const {data} = await Pedidos.historial_estados(id)
        commit('set_historial',data)
    },
    async pedidos_resumenes({commit},id){
        const {data} = await Pedidos.resumenes(id)
        commit('set_resumenes',data)
    },
    async pedido_credito({commit},id){
        const {data} = await Pedidos.get_credito(id)
        commit('set_credito',data)
    },
    async set_data({commit}){
        commit('set_resumenes',{inicial:{},final:{}})
        commit('set_historial',[])
        commit('set_productos',[])
        commit('set_pedido',{})
        commit('set_cliente',{})
        commit('set_id_pedido',null)
    },

}
